// Bundle Add-on Script for Smartrr Products

(function() {
  'use strict';
  
  // Configuration: Map parent variant IDs to bundle variant IDs
  const BUNDLE_CONFIG = {
    '44468312047772': '44572222029980',
    '44546519761052': '44656247079068'
  };

  const productVariants = window.__st?.p?.variants?.map(v => v.id.toString()) || [];
  const hasBundleVariant = productVariants.some(id => BUNDLE_CONFIG[id]);
  if (!hasBundleVariant) return;
  
  // Flag to prevent infinite loops
  let isAddingBundle = false;
  
  // Check if variant needs bundle AND has selling plan
  function shouldAddBundle(variantId, sellingPlan) {
    const bundleVariantId = BUNDLE_CONFIG[variantId];
    const hasSellingPlan = sellingPlan && sellingPlan !== '' && sellingPlan !== null;
    
    // console.log('shouldAddBundle check:', {
    //   variantId,
    //   sellingPlan,
    //   bundleVariantId,
    //   hasSellingPlan,
    //   result: !!(bundleVariantId && hasSellingPlan)
    // });
    
    return bundleVariantId && hasSellingPlan;
  }
  
  // Add bundle product to cart WITHOUT selling plan
  function addBundleProduct(bundleVariantId) {
    if (isAddingBundle) {
      // console.log('Bundle add already in progress, skipping');
      return Promise.resolve();
    }
    
    // console.log('Adding bundle product WITHOUT selling plan:', bundleVariantId);
    isAddingBundle = true;
    
    const cartData = {
      id: bundleVariantId,
      quantity: 1
      // NO selling_plan property - this ensures one-time purchase
    };
    
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // console.log('Bundle product added successfully:', data);
      return data;
    })
    .catch(error => {
      console.error('Error adding bundle product:', error);
      throw error;
    })
    .finally(() => {
      isAddingBundle = false;
      // console.log('Bundle add flag reset');
    });
  }
  
  // Check if the request is for a bundle variant (to avoid intercepting our own additions)
  function isBundleVariantRequest(requestData) {
    try {
      // Handle both direct object and items array
      if (requestData.items && Array.isArray(requestData.items)) {
        return requestData.items.some(item => {
          const variantId = item.id ? item.id.toString() : null;
          return Object.values(BUNDLE_CONFIG).includes(variantId);
        });
      }
      
      const variantId = requestData.id ? requestData.id.toString() : null;
      return Object.values(BUNDLE_CONFIG).includes(variantId);
    } catch (e) {
      return false;
    }
  }
  
  // Extract variant and selling plan info from request
  function extractRequestInfo(requestData) {
    // Handle items array format (used by Smartrr)
    if (requestData.items && Array.isArray(requestData.items) && requestData.items.length > 0) {
      const firstItem = requestData.items[0];
      return {
        variantId: firstItem.id ? firstItem.id.toString() : null,
        sellingPlan: firstItem.selling_plan || ''
      };
    }
    
    // Handle direct format
    return {
      variantId: requestData.id ? requestData.id.toString() : null,
      sellingPlan: requestData.selling_plan || ''
    };
  }
  
  // Intercept all fetch requests to /cart/add.js
  function interceptCartAdditions() {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      const [url, options] = args;
      
      // Check if this is a cart add request
      if (url && url.includes('/cart/add.js') && options && options.method === 'POST') {
        
        // Don't intercept if we're adding a bundle product
        if (isAddingBundle) {
          // console.log('Skipping interception - bundle add in progress');
          return originalFetch.apply(this, args);
        }
        
        try {
          // Parse the request body
          const requestData = typeof options.body === 'string' 
            ? JSON.parse(options.body) 
            : options.body;
          
          // console.log('Cart add intercepted:', requestData);
          
          // Skip if this is the bundle variant being added
          if (isBundleVariantRequest(requestData)) {
            // console.log('Skipping - this is a bundle variant');
            return originalFetch.apply(this, args);
          }
          
          // Extract variant and selling plan info
          const { variantId, sellingPlan } = extractRequestInfo(requestData);
          const bundleVariantId = BUNDLE_CONFIG[variantId];
          
          // Check if we should add bundle
          if (shouldAddBundle(variantId, sellingPlan)) {
            // console.log('✅ Will add bundle (WITHOUT selling plan) after main product');
            
            // Execute original cart add first
            return originalFetch.apply(this, args)
              .then(response => {
                if (response.ok) {
                  // Add bundle product WITHOUT selling plan
                  return addBundleProduct(bundleVariantId)
                    .then(() => {
                      // console.log('Bundle added successfully, returning original response');
                      return response;
                    })
                    .catch(error => {
                      console.error('Bundle add failed, but main product was added:', error);
                      return response;
                    });
                }
                return response;
              });
          } else {
            // console.log('❌ No bundle will be added - either no selling plan or variant not in config');
          }
          
        } catch (error) {
          console.error('Error parsing cart request:', error);
        }
      }
      
      // For all other requests, use original fetch
      return originalFetch.apply(this, args);
    };
    
    // console.log('Bundle script initialized - fetch interceptor active');
  }
  
  // Initialize
  function initialize() {
    // console.log('Bundle Add-on Script: Initializing');
    // console.log('Configured variants:', BUNDLE_CONFIG);
    interceptCartAdditions();
  }
  
  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
})();